export enum SearchFilterAttribute {
  STATUS = 'parent.status',
  PRICE_UNIT = 'pricePerUnitFloat',
  PRICE_TOTAL = 'valueFloat',
  PLANNED_VALUE = 'plannedValueFloat',
  CREATED_AT = 'createdAtTimestamp',
  ORDERED_AT = 'parent.orderedAtTimestamp',
  REQUESTED_AT = 'requestedAtTimestamp',
  SUPPLIER_ID_PARENT = 'parent.supplierId',
  SUPPLIER_ID = 'supplierId',
  COMMODITY_GROUP_ID = 'commodityGroupId',
  VALID_FROM = 'parent.validFromTimestamp',
  VALID_TO = 'parent.validToTimestamp',
  SOURCING_PROJECT_STATUS = 'sourcingProject.status',
  SOURCING_PROJECT_VARIANT = 'sourcingProject.variant',
  SOURCING_PROJECT_COMMODITY_GROUP_ID = 'sourcingProject.commodityGroupId',
  SOURCING_PROJECT_SUPPLIER_IDS = 'sourcingProject.supplierIds',
}
